import { render } from "./IsoHospital.vue?vue&type=template&id=7866fa2f&scoped=true"
import script from "./IsoHospital.vue?vue&type=script&lang=js"
export * from "./IsoHospital.vue?vue&type=script&lang=js"

import "./IsoHospital.vue?vue&type=style&index=0&id=7866fa2f&scoped=true&lang=css"
import "./IsoHospital.vue?vue&type=style&index=1&id=7866fa2f&scoped=true&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7866fa2f"]])

export default __exports__